---
en:
  feature_requests:
    categories:
      api_developer: API/Developer
      feedback: Feedback
      new_feature: New feature
    create_request: Create request
    delete: Delete
    edit_request: Edit request
    filter_category: Filter on category
    filter_status: Filter on status
    mail_support: Mail to support
    model_name: Feature request
    only_admins_can_delete: Only admins can delete feature requests
    plural: Feature requests
    publish: Create
    save: Save
    statuses:
      coming_soon: Coming soon
      investigating: Investigating
      launched: Launched
      new: New
      not_planned: Not planned
